// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_tobenamed5 {
  background: var(--ColorPrimary);
  box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 10px;
  width: 30%;
  height: 30vh;
}
.card_tobenamed5 g {
  margin: 0 auto;
  position: relative;
}

/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .card_tobenamed5 {
    width: auto;
    height: 30%;
  }
  .card_tobenamed5 svg {
    z-index: 2;
  }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/toBeNamedCard5/toBeNamedCard5.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,2GAA2G;AAC3G;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;AACA,kGAAkG;AAClG;AACA","sourcesContent":[".card_tobenamed5 {\n  background: var(--ColorPrimary);\n  box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  padding: 10px;\n  width: 30%;\n  height: 30vh;\n}\n.card_tobenamed5 g {\n  margin: 0 auto;\n  position: relative;\n}\n\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .card_tobenamed5 {\n    width: auto;\n    height: 30%;\n  }\n  .card_tobenamed5 svg {\n    z-index: 2;\n  }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
